<!-- eslint-disable -->
<template lang="pug">
    tr.points__tr--border
        td.points__td(v-if="user.type !== 'student'")
            router-link.points__link(
                :to="{\
                        name: 'user:profile',\
                        params: {\
                            id: progress.user.id,\
                            type: progress.user.type\
                        }\
                    }"
            )
                | {{ progress.user.fullName }}
        td.points__td {{ progress.updatedAt | moment('DD.MM.YYYY (HH:mm:ss)') }}
        td.points__td
            template(v-if="progress.gameExercise && progress.gameExercise.sourceId && progress.gameExercise.sourceDate")
                router-link.points__link(
                    v-if="user.type !== 'student'"
                    :to="{\
                        name: 'homework:edit',\
                        params: {\
                            id: progress.gameExercise.sourceId,\
                            type: 'homework'\
                            }\
                        }"
                )
                   | {{ progress.gameExercise.sourceDate | moment('DD.MM.YYYY') }}
                template(v-else)
                    | {{ progress.gameExercise.sourceDate | moment('DD.MM.YYYY') }}
            template(v-else-if="progress.gameExercise && !progress.gameExercise.sourceId")
                | {{ $i18n.t('progress.progress_homework_deleted') }}
            template(v-else)
                | {{ $i18n.t('progress.progress_homework_freeGame') }}
        td.points__td
            | {{ gameParametersStringField }}
        td.points__td
            template(v-if="progress.isCompleted && progress.game === 'FlashCards'")
                | {{ getTime(progress.parameters.duration*60) }}
            template(v-else)
                | {{ getTime(progress.executionTime) || '&mdash;' }}
        td.points__td
            template(v-if="showDash")
                | &mdash;
            template(v-else)
                | {{ progress.attempts }}
        td.points__td.points__negative(v-if="!progress.isCompleted")
            | {{ $i18n.t('progress.progress_rightPercent_notFinished') }}
        td.points__td(v-else-if="showDash") &mdash;
        td.points__td(:class="progressClass" v-else)
            | {{ percent }}%
        td.points__td(:class="+points > 0 ? 'points__positive' : 'points__negative'") {{ +points || '&mdash;' }}
</template>

<script>
    /*eslint-disable*/
    import ProgressPreviewMixin from '../../../../utils/progressPreviewMixin';
    import TrainerUtilities from '../../../../utils/trainer/trainer';
    import FlashCardsPreviewMixin from '../../../../utils/trainer/FlashCardsPreviewMixin';

    const GAMES_WITH_DASH = ['FlashCards', 'Shutter', 'ShutterOnline', 'Chameleon', 'MentalDrawing', 'HandsUp', 'RepeatAfterMe'];

    export default {
        mixins: [ProgressPreviewMixin, TrainerUtilities, FlashCardsPreviewMixin],
        computed: {
            points () {
                if (this.progress.points > 0 && this.progress.isCompleted) {
                    return `+${this.progress.points}`;
                }
                return false;
            },
            showDash () {
                return GAMES_WITH_DASH.includes(this.progress.game)
                    || ((this.progress.game === 'CatchWord' || this.progress.game === 'CatchWordOnline' || this.progress.game === 'CatchWordReadingEn') && this.progress.parameters.mode === 'static');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .points__td {
        padding: 13px 8px;
        @include media($md) {
            padding: 10px 20px;
        }
    }

    .points__tr--border {
        border-bottom: 1px solid #E6E6F8;
    }

    .points__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        &:hover {
            color: $hsl-color-blue-56;
            text-decoration: none;
        }
    }

    .points__positive {
        color: $hsl-color-green-58;
    }

    .points__warning {
        color: $hsl-color-yellow-66;
    }

    .points__negative {
        color: $hsl-color-red-62;
    }
</style>
